import React, { RefObject, SyntheticEvent } from 'react'

import { FaPause, FaPlay, FaStepBackward, FaStepForward } from 'react-icons/fa'

import {
  Artwork,
  ArtworkAura,
  ArtworkFrame,
  ControlButton,
  Controls,
  NowPlayingPanel,
  PlayerHeader,
  Progress,
} from './styles'

const formatTime = (seconds: number) => {
  if (!Number.isFinite(seconds)) return '0:00'
  return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`
}

interface NowPlayingProps {
  artwork: string
  audioRef: RefObject<HTMLAudioElement>
  category?: string
  currentTime: number
  disabled?: boolean
  duration: number
  playing: boolean
  progressPercentage: number
  source?: string
  title: string
  onEnded: () => void
  onLoadedMetadata: (event: SyntheticEvent<HTMLAudioElement>) => void
  onNext: () => void
  onPrevious: () => void
  onSeek: (value: number) => void
  onTimeUpdate: (event: SyntheticEvent<HTMLAudioElement>) => void
  onTogglePlay: () => void
}

const NowPlaying = ({
  artwork,
  audioRef,
  category,
  currentTime,
  disabled = false,
  duration,
  onEnded,
  onLoadedMetadata,
  onNext,
  onPrevious,
  onSeek,
  onTimeUpdate,
  onTogglePlay,
  playing,
  progressPercentage,
  source,
  title,
}: NowPlayingProps) => (
  <NowPlayingPanel>
    <PlayerHeader>
      <div>
        <span>Reproduciendo ahora</span>
        <h3>{title}</h3>
        <p>{category}</p>
      </div>
    </PlayerHeader>
    <ArtworkFrame $active={playing}>
      <ArtworkAura $active={playing} aria-hidden="true">
        <i />
        <i />
        <i />
      </ArtworkAura>
      <Artwork src={artwork} alt="" />
    </ArtworkFrame>
    <audio
      ref={audioRef}
      src={source}
      onLoadedMetadata={onLoadedMetadata}
      onTimeUpdate={onTimeUpdate}
      onEnded={onEnded}
    />
    <Progress
      $progress={progressPercentage}
      type="range"
      min="0"
      max={duration || 0}
      value={Math.min(currentTime, duration || 0)}
      onChange={(event) => onSeek(Number(event.target.value))}
      aria-label="Progreso del ejercicio"
      aria-valuetext={`${formatTime(currentTime)} de ${formatTime(duration)}`}
      disabled={disabled}
    />
    <div className="time">
      <span>{formatTime(currentTime)}</span>
      <span>{formatTime(duration)}</span>
    </div>
    <Controls>
      <ControlButton
        type="button"
        onClick={onPrevious}
        disabled={disabled}
        aria-label="Ejercicio anterior"
      >
        <FaStepBackward aria-hidden="true" />
      </ControlButton>
      <ControlButton
        $primary
        type="button"
        onClick={onTogglePlay}
        disabled={disabled}
        aria-label={playing ? 'Pausar ejercicio' : 'Reproducir ejercicio'}
      >
        {playing ? (
          <FaPause aria-hidden="true" />
        ) : (
          <FaPlay aria-hidden="true" />
        )}
      </ControlButton>
      <ControlButton
        type="button"
        onClick={onNext}
        disabled={disabled}
        aria-label="Siguiente ejercicio"
      >
        <FaStepForward aria-hidden="true" />
      </ControlButton>
    </Controls>
  </NowPlayingPanel>
)

export default NowPlaying
